import React from 'react';
import useStateControls from '../../../../hooks/useStateControls';
import Back from '../../../features/back/Back';
import { START } from '../../../../constants/shared/states/names';

const RulesHeader = React.forwardRef(function ({ isModal, closeModal }, ref) {
  const { setState } = useStateControls();

  return (
    <div className={'rules__header'}>
      <Back
        onClick={() => {
          isModal ? closeModal?.() : setState(START);
        }}
      />
    </div>
  );
});
export default RulesHeader;
RulesHeader.propTypes = {};
